import styles from '../styles/components/spacer.module.scss';

interface SpacerProps {
    size?: "xtraTiny" | "tiny" | "small" | "base" | "medium" | "large" | "jumbo";
}

export default function Spacer({ size = "base" }: SpacerProps) {

    return <div className={styles[`spacer--${size}`]} />;
}